import MenuListByRole from '@sendbird/uikit-react/ChannelSettings/components/ChannelSettingMenuList';
import { useChannelSettingsContext } from '@sendbird/uikit-react/ChannelSettings/context';
import useMenuItems from '@sendbird/uikit-react/ChannelSettings/hooks/useMenuList';
import { MemberList } from './MembersList';
import { MutedMembersList } from './MutedMembersList';
import { OperatorsList } from './OperatorsList';

export const CustomModerationPanel = () => {
  const menuItems = useMenuItems();
  const { renderUserListItem } = useChannelSettingsContext();

  // Remove banned users from the operator menu items since we dropped this feature
  const { bannedUsers: _bannedUsers, ...menuItemsWithoutBannedUsers } =
    menuItems.operator;

  const customMenuItems: typeof menuItems = {
    operator: {
      ...menuItemsWithoutBannedUsers,
      operators: {
        ...menuItems.operator.operators!,
        accordionComponent: () => (
          <OperatorsList renderUserListItem={renderUserListItem} />
        ),
      },
      allUsers: {
        ...menuItems.operator.allUsers!,
        accordionComponent: () => (
          <MemberList canInviteUsers renderUserListItem={renderUserListItem} />
        ),
      },
      mutedUsers: {
        ...menuItems.operator.mutedUsers!,
        accordionComponent: () => (
          <MutedMembersList renderUserListItem={renderUserListItem} />
        ),
      },
    },
    nonOperator: {
      ...menuItems.nonOperator,
      allUsers: {
        ...menuItems.operator.allUsers!,
        accordionComponent: () => (
          <MemberList
            canInviteUsers={false}
            renderUserListItem={renderUserListItem}
          />
        ),
      },
    },
  };

  return <MenuListByRole menuItems={customMenuItems} />;
};
